export interface AccountSettings {
    passCode?: string;
    preferredLanguage?: string;
    pageSize?: number;
    countryCode?: string;
    salesOrdersV2DataSource?: string;
    salesOrderV2_5NewLayout?: boolean;
    salesOrderV2_5MultiPayment?: boolean;
    /** One preview for every purchasing and invoicing document (US 28104) */
    newDocumentLayout?: boolean;
    /** @deprecated replaced by `newDocumentLayout`; still read so accounts that had it on keep the new layout */
    purchaseOrderNewLayout?: boolean;
}

/** Off by default; an account that had the purchase order preview on is migrated to the new flag */
export function isNewDocumentLayoutEnabled(settings?: AccountSettings): boolean {
    return settings?.newDocumentLayout ?? settings?.purchaseOrderNewLayout ?? false;
}

export interface OrganizationSettings {
    id: string;
    defaultWarehouseId?: number;
    defaultSalesPersonId?: number;
    defaultCustomerId?: number;
    defaultArAccountId?: number;
    defaultCashAccountId?: number;
    defaultBankAccountId?: number;
    defaultPrintTemplateId?: number;
    defaultRawMaterialsWarehouseId?: number;
    defaultFinishedGoodsWarehouseId?: number;
    manufacturing?: ManufacturingSettings;
}

export interface ManufacturingSettings {
    startProductionOtherPartyId?: number;
    completeProductionOtherPartyId?: number;
}
